import { IIconProps } from '#components/icons/types';

const ChevronUp = ({ size = 48, color = '#fff' }: IIconProps) => (
  <svg
    className="svg-icon"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    fill={color}
  >
    <path d="M0 0h24v24H0V0z" fill="none" stroke="none" />
    <path d="M12 8.59L6.41 14.17 7.83 15.59 12 11.41 16.17 15.59 17.59 14.17 12 8.59z" />
  </svg>
);

export default ChevronUp;
